<script setup>
const emit = defineEmits(["update:modelValue"]);
defineProps({
  name: {
    type: String,
    required: true,
  },
  groupName: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

function onChange(event) {
  emit("update:modelValue", event.target.value);
}
</script>
<template>
  <div class="form-check">
    <input
      :id="id"
      class="form-check-input"
      type="radio"
      :name="groupName || name"
      :value="name"
      :checked="modelValue === name"
      :disabled="disabled"
      @change="onChange"
    />
    <label class="form-check-label custom-control-label" :for="id">
      <slot />
    </label>
  </div>
</template>
